import imagesLoaded from "imagesloaded";
import preventDefault from "@grrr/utils/functions/preventDefault";
import Isotope from "isotope-layout";

export const masonry = function (el) {
    const selector = el.getAttribute("data-selector");
    const container = el.getAttribute("data-container");
    let isotope;
    imagesLoaded(
        el.querySelectorAll(".publications__item-background"),
        { background: true },
        function () {
            console.log("#container background image loaded");
            isotope = new Isotope(el.querySelector(container), {
                itemSelector: selector,
                percentPosition: true,
                masonry: {
                    horizontalOrder: true,
                    gutter: 25,
                },
            });
        }
    );
    const filters = el.querySelectorAll("[data-filter]");
    filters.forEach(function (element) {
        element.addEventListener("click", function (evt) {
            preventDefault(evt);
            const filterName = element.getAttribute("data-filter");

            if (!element.classList.contains("active")) {
                filters.forEach(function (element) {
                    element.classList.remove(
                        "scheme--background-color",
                        "scheme--color-black",
                        "active"
                    );
                    element.classList.add(
                        "scheme--color-white",
                        "scheme--background-color-black"
                    );
                });
                element.classList.add(
                    "scheme--background-color",
                    "scheme--color-black",
                    "active"
                );
                element.classList.remove(
                    "scheme--color-white",
                    "scheme--background-color-black"
                );
                isotope.arrange({
                    filter: "." + filterName,
                });
            } else {
                element.classList.remove(
                    "scheme--background-color",
                    "scheme--color-black",
                    "active"
                );
                element.classList.add(
                    "scheme--color-white",
                    "scheme--background-color-black"
                );
                isotope.arrange({
                    filter: "*",
                });
            }
        });
    });
};
